import {
  DiscountCodeType,
  IDiscountCode,
  IDiscountCodeRule,
} from "@evennt-tech/api-v2-core";
import { parseCents } from "tools/product/formats/formatCents";
import { DiscountCodeError } from "view/apps/Exhibitor/pages/Cart/components/DiscountCodes/helpers";
import Big from "big.js";

export const parseResponseDiscountCode = (
  code: IDiscountCode
): IDiscountCode => ({
  ...code,
  rules: code.rules?.map((rule) => ({
    ...rule,
    amount:
      rule.type === DiscountCodeType.Fixed
        ? parseCents(rule.amount)
        : rule.amount,
  })),
});

export const validateDiscountCodeCategories = (
  discountCodeCategories: string[] = [],
  supplierCompanyId: string,
  categoryIdsBySupplier: Record<string, Set<string>>
): DiscountCodeError | null => {
  if (!discountCodeCategories.length) {
    if (!Object.keys(categoryIdsBySupplier).includes(supplierCompanyId)) {
      return DiscountCodeError.NoMatchingProducts;
    }
    return null;
  }

  const hasAnyMatchingCategory = discountCodeCategories.some((cat) =>
    Object.values(categoryIdsBySupplier).some((catIds) => catIds.has(cat))
  );
  if (!hasAnyMatchingCategory) {
    return DiscountCodeError.CategoryMismatch;
  }

  const hasMatchingSupplierCategories = discountCodeCategories.some((cat) =>
    categoryIdsBySupplier[supplierCompanyId]?.has(cat)
  );
  if (!hasMatchingSupplierCategories) {
    return DiscountCodeError.NoMatchingProducts;
  }

  return null;
};

export const hasDiscountCodeAmountChanged = (
  currentCode: IDiscountCode,
  updatedCode: IDiscountCode
): boolean => {
  const currentAmountRule = currentCode.rules?.[0];
  const updatedAmountRule = updatedCode.rules?.[0];
  if (!updatedAmountRule || !currentAmountRule) {
    return false;
  }

  return (
    currentAmountRule.type !== updatedAmountRule.type ||
    !new Big(currentAmountRule.amount).eq(updatedAmountRule.amount)
  );
};

export const isDiscountCodeFixed = <T extends IDiscountCode>(
  discountCode: T
): discountCode is T & { rules: IDiscountCodeRule[] } =>
  discountCode.rules?.[0]?.type === DiscountCodeType.Fixed;
